var Utils = require('../lib/utils');

module.exports = {
    getPainterEffectTimeline: function(sprite, name) {

        var timeline = new TimelineMax({
            repeat: -1,
        });

        switch (name)
        {
            case 'torchGuyEffect':
                var alphaTimeline = new TimelineMax({
                    yoyo: true,
                    repeat: 1
                })
                .fromTo(sprite, 0.01, {
                    alpha: 0.7,
                },{
                    alpha: 1
                });

                var scaleTimeline = new TimelineMax({
                    yoyo: true,
                    repeat: 1
                })
                .fromTo(sprite.scale, 0.02, {
                    x: '-=1',
                    y: '-=0.6'
                },{
                    x: '+=0.4',
                    y: '+=0.25'
                });
                timeline.add(alphaTimeline, 0);
                timeline.add(scaleTimeline, 0);
            break;

            case 'sprayGuyEffect':
                timeline.fromTo(sprite, 0.005, {
                    alpha: 0.8,
                },{
                    alpha: 1,
                    yoyo: true,
                    repeat: 1
                });
            break;

            case 'laserGuyEffect':
                timeline.fromTo(sprite, 0.08, {
                    alpha: 1,
                },{
                    alpha: 0.3,
                    yoyo: true,
                    repeat: 1
                });
            break;
        }

        return timeline;
    },

    updateMovieclipFrameEffect: function(movieclip, opts, audios)
    {
        opts = _.extend({
            allObjects: {},
            sprites: {}
        }, opts);

        if (!movieclip.visible)
        {
            return;
        }

        var frame = movieclip.currentFrame;

        var objs = opts.allObjects;
        var movieclipObject =  _.get(objs, movieclip.name);

        var effectKey = _.get(movieclipObject, 'effectSpriteKey');
        var effectObject = _.get(objs, effectKey);
        var effectCount = _.get(effectObject, 'count', 1);

        for (var i = 0; i < effectCount; i++)
        {
            var effectSprite = _.get(opts.sprites, effectKey+i, null);
            var effectPosition = _.get(movieclipObject, 'effectPositions.'+frame+'.'+i, null);
            if (effectSprite)
            {
                effectSprite.visible = _.get(effectPosition, 'position', false) ? true : false;

                if (effectSprite.visible)
                {
                    var sizeAndPosition = _.extend(effectObject, effectPosition);
                    Utils.setSizeAndPositionFromRefSprite(effectSprite, movieclip, sizeAndPosition);
                    var playOpts = {
                        time: 0
                    };
                    switch(effectKey) {
                        case 'torchGuyEffect':
                            // audios.torch.play(playOpts);
                        break;
                        case 'sprayGuyEffect':
                            audios['spray'+_.random(1,2)].play(playOpts);
                        break;
                        case 'laserGuyEffect':
                            audios.laser.play(playOpts);
                        break;
                    }
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./js/animations/painters.js